import { create } from 'zustand';

import {
    sendVehicleChanges,
    sendUpsertVehicleChanges
} from '../channels/tripVehiclesChangesChannel';

export const useTripVehiclesChangesStore = create((set, get) => ({

    vehicleChanges: {},

    // =========================
    // SET BATCH
    // =========================

    setVehicleChangesBatch: (
        changes = [],
        broadcast = true
    ) => {

        const next = {};

        for (const change of changes) {

            if (!change?.tripUid) {
                continue;
            }

            if (!next[change.tripUid]) {
                next[change.tripUid] = [];
            }

            next[change.tripUid].push(
                change
            );
        }

        set({
            vehicleChanges: next
        });

        if (broadcast) {
            sendVehicleChanges(changes);
        }
    },

    // =========================
    // UPSERT
    // =========================

    upsertVehicleChange: (
        change,
        broadcast = true
    ) => {

        if (
            !change?.tripUid ||
            !change?.queueId
        ) {
            return;
        }

        const current =
            get().vehicleChanges;

        const tripChanges =
            current[change.tripUid] || [];

        const index =
            tripChanges.findIndex(
                item =>
                    item.queueId ===
                    change.queueId
            );

        let nextTripChanges;

        if (index === -1) {

            nextTripChanges = [
                ...tripChanges,
                change
            ];

        } else {

            nextTripChanges = [
                ...tripChanges
            ];

            nextTripChanges[index] =
                change;
        }

        set({
            vehicleChanges: {
                ...current,
                [change.tripUid]:
                    nextTripChanges
            }
        });

        if (broadcast) {
            sendUpsertVehicleChanges(change);
        }
    },

    // =========================
    // GET TRIP CHANGES
    // =========================

    getTripVehicleChanges: (tripUid) => {

        return (
            get().vehicleChanges[tripUid] ||
            []
        );
    },

    // =========================
    // GET LAST CHANGE
    // =========================

    getLastTripVehicleChange: (tripUid) => {

        if (!tripUid) {
            return null;
        }

        const changes =
            get().vehicleChanges[tripUid] || [];

        if (!changes.length) {
            return null;
        }

        return changes.reduce(
            (latest, change) => {

                if (!latest) {
                    return change;
                }

                const currentDate =
                    new Date(
                        change.createdAt
                    ).getTime();

                const latestDate =
                    new Date(
                        latest.createdAt
                    ).getTime();

                return currentDate > latestDate
                    ? change
                    : latest;

            },
            null
        );
    },

    // =========================
    // CLEAR
    // =========================

    clearVehicleChanges: (
        broadcast = true
    ) => {

        set({
            vehicleChanges: {}
        });

        if (broadcast) {
            sendVehicleChanges([]);
        }
    },

    // =========================
    // SEND SNAPSHOT
    // =========================

    sendVehicleChangesSnapshot: () => {

        const changes =
            Object.values(
                get().vehicleChanges
            ).flat();

        sendVehicleChanges(changes);
    }

}));